import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useNotification } from '../context/NotificationContext';
import { formatNumberPersian } from '../utils/mobileUtils';
import { formatPrice } from '../utils/priceUtils';
import { getImageUrl } from '../utils/urlUtils';
import './Cart.css';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getTotalPrice, clearCart } = useCart();
  const { isAuthenticated } = useAuth();
  const { isDarkMode } = useTheme();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const getPlaceholderImage = (text = 'Product', width = 100, height = 100) => {
    const svg = `
      <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
        <rect width="${width}" height="${height}" fill="#f0f0f0"/>
        <text x="50%" y="50%" font-family="Vazirmatn, sans-serif" font-size="${Math.min(width, height) / 10}" fill="#999" text-anchor="middle" dominant-baseline="middle">${text}</text>
      </svg>
    `.trim();
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
  };

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      showNotification('سبد خرید شما خالی است', 'error');
      return;
    }

    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    navigate('/checkout');
  };

  if (cartItems.length === 0) {
    return (
      <div className={`cart-container ${isDarkMode ? 'dark' : ''}`}>
        <div className="cart-header">
          <h1>سبد خرید</h1>
          <button className="back-btn" onClick={() => navigate('/')}>
            → بازگشت به فروشگاه
          </button>
        </div>
        <div className="empty-cart">
          <p>سبد خرید شما خالی است</p>
          <button className="btn-primary" onClick={() => navigate('/')}>
            ادامه خرید
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`cart-container ${isDarkMode ? 'dark' : ''}`}>
      <div className="cart-header">
        <h1>سبد خرید</h1>
        <button className="back-btn" onClick={() => navigate('/')}>
          → بازگشت به فروشگاه
        </button>
      </div>

      <div className="cart-content">
        <div className="cart-items">
          {cartItems.map(item => (
            <div key={item.productId} className="cart-item">
              <div className="cart-item-image">
                <img 
                  src={getImageUrl(item.product.imageUrl) || getPlaceholderImage(item.product.name, 100, 100)} 
                  alt={item.product.name}
                  onError={(e) => {
                    e.target.src = getPlaceholderImage(item.product.name, 100, 100);
                  }}
                />
              </div>
              <div className="cart-item-info">
                <h3>{item.product.name}</h3>
                <p className="cart-item-category">{item.product.category?.name || item.product.category || 'بدون دسته‌بندی'}</p>
                <div className="cart-item-price">{formatPrice(item.product.price)}</div>
              </div>
              <div className="cart-item-quantity">
                <button 
                  onClick={() => updateQuantity(item.productId, item.quantity - 1)}
                  className="quantity-btn"
                >
                  -
                </button>
                <span className="quantity-value">{formatNumberPersian(item.quantity)}</span>
                <button 
                  onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                  className="quantity-btn"
                >
                  +
                </button>
              </div>
              <div className="cart-item-total">
                {formatPrice(item.product.price * item.quantity)}
              </div>
              <button 
                className="remove-btn"
                onClick={() => removeFromCart(item.productId)}
              >
                ×
              </button>
            </div>
          ))}
        </div>

        <div className="cart-summary">
          <h2>خلاصه سفارش</h2>
          <div className="summary-row">
            <span>جمع کل:</span>
            <span>{formatPrice(getTotalPrice())}</span>
          </div>
          <div className="summary-row">
            <span>هزینه ارسال:</span>
            <span>رایگان</span>
          </div>
          <div className="summary-total">
            <span>مبلغ قابل پرداخت:</span>
            <span>{formatPrice(getTotalPrice())}</span>
          </div>
          <button className="checkout-btn" onClick={handleCheckout}>
            ادامه و تکمیل سفارش
          </button>
          <button className="clear-cart-btn" onClick={clearCart}>
            پاک کردن سبد خرید
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;


